
import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useState } from 'react';
import {ISalaryComponent, ISalaryComponentSearch } from "../models/SalaryComponent";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';


import { currentUserSessionAtom } from 'library/store';
//import { IPolicyRisk, IPolicyRiskCoverage } from 'features/salaryComponention/models/Policy';


const _ = () => {

    const axios = useAxios(); 

    const createSalaryComponent = async (salaryComponent: ISalaryComponent)  =>       
        await (await axios.post('/api/setup/salaryComponent/create', salaryComponent)).data;       
        
    const updateSalaryComponent = async (salaryComponent: ISalaryComponent)  =>       
        await (await axios.post('/api/setup/salaryComponent/update', salaryComponent)).data; 
    
    const getSalaryComponent = async (id  : number )  => {
      const {data} = (await axios.get(`/api/setup/salaryComponent/get-salaryComponent/${id}`));
      return await data;
    }
   

    const getSalaryComponents = async (criteria: ISalaryComponentSearch, pagination?: IPagination) : Promise<ISalaryComponent[]> => {

      const {name, description} = criteria;
      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/setup/salaryComponent/get-salaryComponents?name=${name}&description=${description}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }

    const getAllSalaryComponents = async () : Promise<ISalaryComponent[]> => {

      const {data} = (await axios.get(`/api/setup/salaryComponent/get-all-salaryComponents`));
      return await data;
    }
    
   
    return {    
      createSalaryComponent,
      updateSalaryComponent,
      getSalaryComponent,
      getSalaryComponents,

      getAllSalaryComponents

      
    } 
}

export default _;

export interface IFilterSalaryComponentOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [string[], React.Dispatch<React.SetStateAction<string[]>>],
  stateFiltered?: [ISalaryComponent[], React.Dispatch<React.SetStateAction<ISalaryComponent[]>>],
}

const defaultFilterSalaryComponentOption: IFilterSalaryComponentOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterSalaryComponent = (  type: number, onRowDoubleClick: (event: React.MouseEvent<unknown>, row: ISalaryComponent) => void,
                                            filterOption?: IFilterSalaryComponentOption  ) => {

  const { getSalaryComponents } = _();

  const { t, i18n } = useTranslation();   
  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterSalaryComponentOption;



  const [headSalaryComponentCells, setHeadSalaryComponentCells]  = useState<HeadCell<ISalaryComponent>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', },
    
    {id:'name', label : t('Name'),  display: true, type: 'string', },
    {id:'description', label : t('Description'),  display: true, type: 'string', },
    {id:'isActive', label : t('Active ?'),  display: true, type: 'boolean', },
    

  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [
    
      {name: 'name', text: t('Name'), value: ''},
      {name: 'description', text: t('Description'), value: ''}
     
    ]);    

  const [filteredSalaryComponents, ] = useState<ISalaryComponent[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<ISalaryComponent[]> => {
   
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
   
    const arr = await getSalaryComponents( { name,description}, pagination );
    
    return arr;
  }

  const objKey: keyof ISalaryComponent = 'id';

  return {
    title: t('SalaryComponent'), headCells: headSalaryComponentCells, objKey,
    filterElements, rows: filteredSalaryComponents, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
